import("https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.mjs").then(
  (_ref) => {
    let { Swiper, Navigation } = _ref;
    Swiper.use([Navigation]);
    const swipperFeatured = new Swiper(".featured-quotes__swiper", {
      slidesPerView: "auto",
      spaceBetween: 0,
      keyboard: {
        enabled: true,
      },
      navigation: {
        nextEl: ".featured-quotes__button-next",
        prevEl: ".featured-quotes__button-prev",
      },
      breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1,
            },
            // when window width is >= 480px
            450: {
                slidesPerView: "auto",
            }
        }
    });
  }
);
